import * as i0 from '@angular/core';
import * as i1 from './badge.module';
import * as i2 from './badge.component';
export const NbBadgeModuleNgFactory:i0.NgModuleFactory<i1.NbBadgeModule> = (null as any);
var _decl0_0:i2.NbBadgeComponent = (<any>(null as any));
var _decl0_1:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_2:i0.ElementRef<any> = (<any>(null as any));
function _View_NbBadgeComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbBadgeComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(2,'nb-badge ',_decl0_0.positionClass,
      ' nb-badge-',_decl0_0.colorClass,'');
  currVal_0;
  const currVal_1:any = _decl0_0.text;
  currVal_1;
}
